import { Button, WContainer, WImage } from '@components/atoms'
import useTrans from '@hooks/useTrans'
import { MenuItemType } from '@utils/types'
import styles from './Banner.module.sass'

interface Props {
  className?: string
  item: MenuItemType & { logo?: string }
  theme?: 'white' | 'neutral30' | 'neutral20' | 'neutral10'
  type?: 'left' | 'right'
  editMode?: boolean
}

const Banner = (props: Props) => {
  const {
    className = '',
    item = undefined,
    theme = 'white',
    type = 'left',
    editMode = false,
  } = props

  const classeNames = `
  ${styles.root} 
  ${styles[`root--${theme}`]}
  ${styles[`root--${type}`]}
  ${editMode ? styles['root--editMode'] : ''}
  ${className ? className : ''}`

  const t = useTrans()

  return item ? (
    <div className={`${styles.root} ${classeNames}`}>
      <WContainer>
        <div className={styles.layout}>
          {item?.image && (
            <div className={styles.imageBox}>
              <WImage
                src={item?.image}
                maxWidth={861} // 820 * scale 1.05
                maxHeight={525} // 500 * scale 1.05
                objectFit={'cover'}
                alt={item?.imageAlt}
                title={item?.imageAlt}
                className={styles.image}
              />
            </div>
          )}
          <div className={styles.content}>
            {item.logo && (
              <div className={styles.mediaLogo}>
                <WImage maxHeight={76} maxWidth={286} alt={item?.imageAlt} src={item.logo} />
              </div>
            )}
            {item?.intro && <p className={styles.intro}>{item.intro}</p>}
            {item?.name && (
              <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: item.name }} />
            )}
            {item.description && (
              <div
                className={`${styles.descrizione} ${styles['descrizione--desktop']}`}
                dangerouslySetInnerHTML={{ __html: item?.description }}
              />
            )}
            {!!item.url && (
              <Button
                label={item.ctaLabel || t('Approfondisci')}
                href={item.url}
                variant="ghost"
                newPage={item.blank}
                size="lg"
                className={styles.buttonDesktop}
              />
            )}
          </div>
          <div className={styles.contentMobile}>
            {item.description && (
              <div
                className={styles.descrizione}
                dangerouslySetInnerHTML={{ __html: item?.description }}
              />
            )}
            {!!item.url && (
              <Button
                label={item.ctaLabel || t('Approfondisci')}
                href={item.url}
                variant="ghost"
                newPage={item.blank}
                size="lg"
                className={styles.ctaMobile}
              />
            )}
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default Banner
